import { render, staticRenderFns } from "./DeleteRelEntityEventDialog.vue?vue&type=template&id=45c4d6d2"
import script from "./DeleteRelEntityEventDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRelEntityEventDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports